import React, { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Gauge from "./Gauge";
import { useLocation, useNavigate } from "react-router-dom";

function PowerCard({ deviceId }) {

    const navigate = useNavigate();
    const location = useLocation();

    const [now, setNow] = useState(Date.now());

    const base = location.pathname.startsWith("/admin") ? "/admin" : "/user";

    const reading = useSelector(
        (state) => state.liveMonitor.readings[deviceId]
    )

    console.log("REDUX READING:", {
        deviceId,
        reading,
        Ddate: reading?.Ddate,
        Dtime: reading?.Dtime,
    });


    // Online / Offline
    useEffect(() => {
        const interval = setInterval(() => {
            setNow(Date.now())
        }, 1000);

        return () => clearInterval(interval)
    }, [])

    if (!reading) {
        return (
            <div className="p-6 border rounded-xl text-slate-600 text-center">
                Loading...
            </div>
        );
    }

    const {
        DeviceId,
        DiviceName,
        Ddate,
        Dtime,
        VoltageAB,
        VoltageBC,
        VoltageCA,
        VoltageAN,
        VoltageBN,
        VoltageCN,
        CurrentA,
        CurrentB,
        CurrentC,
        CurrentN,
        TotalActivePowerKW,
        TotalReactivePowerKVAR,
        TotalApparentPowerKVA,
        PowerFactor,
        FrequencyHz,
        ActiveEnergyKWh,
        ReactiveEnergyKVARh
    } = reading;

    // Convert string values from API into numbers
    const voltageAB = Number(VoltageAB || 0);
    const voltageBC = Number(VoltageBC || 0);
    const voltageCA = Number(VoltageCA || 0);

    const currentA = Number(CurrentA || 0);
    const currentB = Number(CurrentB || 0);
    const currentC = Number(CurrentC || 0);

    const pf = Number(PowerFactor || 0);

    // Calculate average voltage and average current for gauge displays
    const avgVoltage = (voltageAB + voltageBC + voltageCA) / 3;
    const avgCurrent = (currentA + currentB + currentC) / 3;

    const readingTimestamp = new Date(`${Ddate}T${Dtime}`);

    const differenceSeconds =
        (now - readingTimestamp.getTime()) / 1000;

    const isOnline = differenceSeconds <= 180;

    console.log("DEVICE ONLINE CHECK:", {
        deviceId,
        Ddate,
        Dtime,
        now: new Date(now).toString(),
        readingTimestamp: readingTimestamp.toString(),
        differenceSeconds,
        isOnline,
    });

    return (
        <div
            onClick={() => navigate(`${base}/live/${deviceId}`)} 
            className="flex flex-col bg-white gap-3 px-0 py-6 md:p-6 border border-border rounded-3xl hover:shadow-xl cursor-pointer transition-all"
        >
            {/* Heading
            <div className="flex w-full justify-between">

                <p className="font-semibold">{DeviceId}</p>

                <p className="font-semibold">{DiviceName ? DiviceName : "N/A"}</p>

                <div className={`flex gap-2 items-center font-semibold rounded-full`}>
                    <p>PF: {PowerFactor ? PowerFactor : "N/A"}</p>
                </div>
            </div> */}

            <div className="flex justify-between items-start px-4 md:p-0">
                <div>
                    <h3 className="text-lg md:text-xl font-bold">
                        {DeviceId}
                    </h3>

                    <p className="text-textSecondary md:text-base text-sm">
                        {DiviceName || "Unnamed Device"}
                    </p>
                </div>

                <div className="flex gap-3 items-center">
                    <div className="px-3 py-1 rounded-full bg-electricBlue/10 text-electricBlue font-semibold text-center text-sm md:text-base">
                        PF {pf.toFixed(2)}
                    </div>

                    <div className={`hidden lg:block px-3 py-1 rounded-full ${
                        isOnline ? "bg-green-100 text-green-500" : "bg-red-100 text-red-500"
                    } font-semibold text-center text-sm md:text-base`}>
                        {isOnline ? "Online" : "Offline"}
                    </div>

                    <div className="relative flex h-3 w-3 md:hidden">
                        <span
                            className={`absolute inline-flex h-full w-full rounded-full ${
                                isOnline ? "bg-green-400" : "bg-red-400"
                            } opacity-75 animate-ping`}
                        />
                        <span
                            className={`relative inline-flex h-3 w-3 rounded-full ${
                                isOnline ? "bg-green-500" : "bg-red-500"
                            }`}
                        />
                    </div>
                </div>
            </div>

            {/* Desktop View */}
            <div className="hidden md:flex items-center justify-between mb-6">
                {/* Current Gauge & details */}
                <div className="flex flex-col gap-8">
                    <Gauge
                        value={avgCurrent}
                        min={0}
                        max={500}
                        width={180}
                        unit="A"
                        segments={[
                            {
                                from: 0,
                                to: 100,
                                color: "#3B82F6",
                            },
                            {
                                from: 100,
                                to: 400,
                                color: "#E5E7EB",
                            },
                            {
                                from: 400,
                                to: 500,
                                color: "#DC2626",
                            },
                        ]}
                    />

                    {/* Individual info box */}
                    {/* <div className="items-center">
                        <p>Current A: {CurrentA}</p>
                        <p>Current B: {CurrentB}</p>
                        <p>Current C: {CurrentC}</p>
                        <p>Current N: {CurrentN}</p>
                    </div> */}
                </div>

                {/* Voltage Gauge & details */}
                <div className="flex justify-center flex-col gap-8">
                    <div className="flex justify-center">
                        <Gauge
                            value={avgVoltage}
                            min={0}
                            max={500}
                            width={180}
                            unit="V"
                            segments={[
                                {
                                    from: 0,
                                    to: 100,
                                    color: "#3B82F6",
                                },
                                {
                                    from: 100,
                                    to: 400,
                                    color: "#E5E7EB",
                                },
                                {
                                    from: 400,
                                    to: 500,
                                    color: "#DC2626",
                                },
                            ]}
                        />
                    </div>

                    {/* Individual info box
                    <div className="flex gap-4">
                        <div>
                            <p>AB: {VoltageAB} V</p>
                            <p>BC: {VoltageBC} V</p>
                            <p>CA: {VoltageCA} V</p>
                        </div>

                        <div className="">
                            <p>AN: {VoltageAN}</p>
                            <p>BN: {VoltageBN}</p>
                            <p>CN: {VoltageCN}</p>
                        </div>
                    </div>     */}
                </div>
            </div>

            {/* DESKTOP KPI Section */}
            <div className="hidden md:grid grid-cols-3 gap-3">

                {/* Left Section */}
                {/* <div>
                    <p>Total Active Power: {TotalActivePowerKW} Kw</p>
                    <p>Total Reactive Power: {TotalReactivePowerKVAR} KVAR</p>
                    <p>Total Apparent Power: {TotalApparentPowerKVA} KVA</p>
                </div> */}

                {/* Right Section */}
                {/* <div>
                    <p>Active Energy: {ActiveEnergyKWh} KWh</p>
                    <p>Reactive Energy: {ReactiveEnergyKVARh} KVARh</p>
                    <p>Frequency: {FrequencyHz} Hz</p>
                </div> */}

                <MetricDisplay 
                    label="Tot. Active Power"
                    value={TotalActivePowerKW}
                    unit="Kw"
                />

                <MetricDisplay 
                    label="Tot. Reactive Power"
                    value={TotalReactivePowerKVAR}
                    unit="KVAR"
                />

                <MetricDisplay 
                    label="Tot. Apparent Power"
                    value={TotalApparentPowerKVA}
                    unit="KVA"
                />

                <MetricDisplay 
                    label="Active Energy"
                    value={ActiveEnergyKWh}
                    unit="KWh"
                />

                <MetricDisplay 
                    label="Reactive Energy"
                    value={ReactiveEnergyKVARh}
                    unit="KVARh"
                />

                <MetricDisplay 
                    label="Frequency"
                    value={FrequencyHz}
                    unit="Hz"
                />
            </div>

            {/* Mobile View ONLY */}
            <div className="md:hidden flex gap-2 px-3">
                {/* First Column */}
                <div className="flex-1 flex flex-col gap-3 items-center">
                    <Gauge
                        value={avgCurrent}
                        min={0}
                        max={500}
                        width={135}
                        unit="A"
                        segments={[
                            {
                                from: 0,
                                to: 100,
                                color: "#3B82F6",
                            },
                            {
                                from: 100,
                                to: 400,
                                color: "#E5E7EB",
                            },
                            {
                                from: 400,
                                to: 500,
                                color: "#DC2626",
                            },
                        ]}
                    />

                    <div className="w-full flex flex-col gap-2">
                        <MetricDisplay 
                            label="Tot. Active Power"
                            value={TotalActivePowerKW}
                            unit="Kw"
                        />

                        <MetricDisplay 
                            label="Tot. Reactive Power"
                            value={TotalReactivePowerKVAR}
                            unit="KVAR"
                        />

                        <MetricDisplay 
                            label="Tot. Apparent Power"
                            value={TotalApparentPowerKVA}
                            unit="KVA"
                        />
                    </div>
                </div>

                {/* Second Column */}
                <div className="flex-1 flex flex-col gap-3 items-center">
                    <Gauge
                        value={avgVoltage}
                        min={0}
                        max={500}
                        width={135}
                        unit="V"
                        segments={[
                            {
                                from: 0,
                                to: 100,
                                color: "#3B82F6",
                            },
                            {
                                from: 100,
                                to: 400,
                                color: "#E5E7EB",
                            },
                            {
                                from: 400,
                                to: 500,
                                color: "#DC2626",
                            },
                        ]}
                    />

                    <div className="w-full flex flex-col gap-2">
                        <MetricDisplay 
                            label="Active Energy"
                            value={ActiveEnergyKWh}
                            unit="KWh"
                        />

                        <MetricDisplay 
                            label="Reactive Energy"
                            value={ReactiveEnergyKVARh}
                            unit="KVARh"
                        />

                        <MetricDisplay 
                            label="Frequency"
                            value={FrequencyHz}
                            unit="Hz"
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

function MetricDisplay({ label, value, unit }) {
    return (
        <div className="bg-surfaceSoft rounded-xl p-3">
            <p className="text-xs text-textSecondary">
                {label}
            </p>

            <div className="flex items-baseline gap-1">
                <span className="font-bold">{value}</span>
                <span className="text-textSecondary">{unit}</span>
            </div>
        </div>
    )
}

export default memo(PowerCard);